var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('button',{on:{"click":_vm.loginWithGoogle}},[_c('img',{attrs:{"alt":"google_signin","src":"img/btn_google_signin_dark_normal_web.png"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }